import React from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';

import s from './styles.module.scss';

import type { ClinicInvoice } from 'infrastructure/classes/clinic-invoice/clinic-invoice';

interface IProps {
  data: ClinicInvoice;
}

const StatusCol: React.FC<IProps> = ({ data }) => {
  const { t } = useTranslation();

  const statusLabel = data.status ? t('labels.active') : t('labels.inactive');

  return (
    <span className={classNames(s.status, data.status && s.active)}>
      {statusLabel}
    </span>
  );
};

export default StatusCol;
